import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isNil, all, propEq } from 'ramda';
import { api } from '../../../../api/requestor';
import AccountContentWrapper from '../../common/AccountContentWrapper/AccountContentWrapper';
import OrderReturn from './OrderReturn';
import FetchingModal from '../../../components/popups/FetchingModal';
import { isDefaultAccountSpa, orderParams } from '../../helpers';
import { getVoluntaryReason, getInvoluntaryReason } from './helpers';
import { getTrueOrder, getReturnableReasons, getSelectedReason, getRefundRules } from '../../../../helpers/account-helper';
import { setTitle } from '../../../../helpers/title-helper';
import { REFERRER, tracktorUrl } from '../../../../constants/settings';
import domainVariants from '../../../../global-variables-provider/domain-variants';
const REMAINING_TICKETS_ARE_INVALID = 'REMAINING_TICKETS_ARE_INVALID';
export default class OrderReturnContainer extends PureComponent {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        orderId: PropTypes.string.isRequired,
        orderToken: PropTypes.string
      })
    }),
    routes: PropTypes.array,
    returnPath: PropTypes.string
  };
  constructor(props) {
    super(props);
    this.state = {
      selectedTickets: [],
      selectedReason: '',
      comment: '',
      commentLength: 0,
      focused: true,
      document: [],
      errorMessage: '',
      reasons: [],
      isModalOpen: false,
      modalUrl: '',
      tracktor: null
    };
  }
  componentDidMount() {
    setTitle(I18n.t('components.OrderReturn.title'));
    import(/* webpackMode: "eager" */'../../../../helpers/tracktor-data-layer').then(tracktorDataLayer => {
      const tracktor = tracktorDataLayer.default;
      this.setState({
        tracktor
      }, () => {
        if (tracktorUrl && domainVariants.isWl) {
          tracktor.push({
            name: 'page_stream',
            version: 2
          }, {
            page: 'busfor_wl_booking_cancel',
            page_category: 'booking',
            url: global.location.href,
            ...(REFERRER && {
              referrer: REFERRER
            })
          });
        }
      });
    });
    api.get.account.order(this.props.match.params.orderId, orderParams).then(({
      data
    }) => {
      const orderData = getTrueOrder(data);
      const returnableReasons = getReturnableReasons(orderData.segments);
      const additionalData = {
        refundRules: getRefundRules(data),
        returnableReasons,
        selectedReason: getSelectedReason(returnableReasons)
      };
      this.setState(() => ({
        ...orderData,
        ...additionalData
      }));
    });
  }
  /**
  * Изменение причины возврата
  */
  onReasonChange = reason => {
    this.setState({
      selectedReason: reason,
      errorMessage: ''
    });
  };
  onCommentChange = ({
    target: {
      value
    }
  }) => {
    this.setState(() => ({
      comment: value,
      commentLength: value.length,
      errorMessage: ''
    }));
  };
  /**
  * Изменение билета для возврата
  */
  onTicketChange = ticketId => {
    const {
      selectedTickets
    } = this.state;
    if (selectedTickets.includes(ticketId)) {
      return this.setState(({
        selectedTickets: tickets
      }) => ({
        errorMessage: '',
        selectedTickets: tickets.filter(ticket => ticket !== ticketId)
      }));
    }
    return this.setState(({
      selectedTickets: tickets
    }) => ({
      errorMessage: '',
      selectedTickets: [...tickets, ticketId]
    }));
  };
  onSubmit = () => {
    const params = {
      orderId: this.state.orderId,
      ticketsIds: this.state.selectedTickets,
      reasonId: this.state.selectedReason,
      comment: this.state.comment,
      ...orderParams
    };
    const {
      tracktor
    } = this.state;
    if (tracktorUrl && tracktor) {
      tracktor.push({
        name: 'button_action',
        version: 1
      }, {
        page: 'cancel_booking_button'
      });
    }
    this.setState({
      isLoading: true,
      errorMessage: ''
    });
    api.post.account.application(params).then(({
      data,
      errors
    }) => {
      if (errors) {
        return this.setState({
          isLoading: false,
          errorMessage: this.getErrorMessage(errors[0].code)
        });
      }
      return data;
    }).then(({
      application_id: id
    }) => {
      const {
        paymentType
      } = this.state;
      if (paymentType === 'offline') {
        api.post.account.uploadFileForRefundApplication({
          id,
          file: this.state.document
        });
      }
      // Перенаправляем человека на страницу заказов
      return window.location.replace(this.getReturnPath());
    });
  };
  onFocus = () => this.setState({
    focused: true
  });
  onBlur = () => this.setState({
    focused: false
  });
  onFileUploaded = ({
    target
  }) => {
    const file = target.files[0];
    if (this.validateUploadFile(file.name)) {
      this.setState({
        document: file,
        errorMessage: ''
      });
    }
  };
  getErrorMessage = code => {
    switch (code) {
      case REMAINING_TICKETS_ARE_INVALID:
        return I18n.t('components.OrderReturn.error.remaining_tickets_error');
      default:
        return I18n.t('components.OrderReturn.error.server');
    }
  };
  getReturnPath = () => {
    const {
      routes,
      returnPath,
      match: {
        params: {
          orderId,
          orderToken
        }
      }
    } = this.props;
    return isDefaultAccountSpa ? returnPath || routes.index.to : routes.order.to(orderId, orderToken);
  };
  isNotificationCheckboxesChecked = () => {
    const {
      refundNotifications
    } = this.state;
    return all(notification => notification.isChecked, refundNotifications);
  };
  clickOnNotificationCheckbox = type => {
    const {
      refundNotifications
    } = this.state;
    const refundNotification = refundNotifications.find(propEq('type', type));
    const {
      isChecked
    } = refundNotification;
    const otherNotification = refundNotifications.find(notification => notification.type !== type);
    const chengedRefundNotifications = [otherNotification, {
      ...refundNotification,
      isChecked: !isChecked,
      type
    }].sort((a, b) => a.position - b.position);
    this.setState({
      refundNotifications: chengedRefundNotifications
    });
  };
  validateUploadFile = file => /(\.jpg|\.jpeg|\.png|\.gif|\.pdf|\.doc|\.docx)$/i.test(file);
  closeModal = () => this.setState({
    isModalOpen: false
  });
  openModal = modalUrl => this.setState({
    isModalOpen: true,
    modalUrl
  });
  render() {
    const {
      selectedTickets,
      selectedReason,
      comment,
      commentLength,
      focused,
      isLoading,
      paymentType,
      segments,
      returnableReasons,
      isModalOpen,
      modalUrl,
      ...restProps
    } = this.state;
    if (isNil(segments)) return null;
    // для Br на фронте ставим причину
    const voluntaryReason = domainVariants.isWlBr ? 'voluntary' : getVoluntaryReason(returnableReasons);
    const inVoluntaryReason = domainVariants.isWlBr ? '' : getInvoluntaryReason(returnableReasons);
    const isCommentValid = !!comment || focused;
    const isVoluntary = selectedReason === 'voluntary';
    const isInVoluntary = selectedReason !== 'voluntary';
    const isPaymentOffline = paymentType === 'offline';
    const isFileUploaded = this.state.document.length !== 0;
    const isFormDisabledDefault = !selectedTickets.length || isInVoluntary && !this.state.comment;
    const isFormDisabledWithDoc = isFormDisabledDefault || !isFileUploaded;
    const isFormDisabled = isPaymentOffline ? isFormDisabledWithDoc : isFormDisabledDefault;
    const isButtonDisabled = isFormDisabled || !this.isNotificationCheckboxesChecked();
    const returnPath = this.getReturnPath();
    return /*#__PURE__*/React.createElement(AccountContentWrapper, {
      returnPath: returnPath
    }, /*#__PURE__*/React.createElement(OrderReturn, {
      ...restProps,
      segments: segments,
      onSubmit: this.onSubmit,
      onReasonChange: this.onReasonChange,
      onTicketChange: this.onTicketChange,
      onCommentChange: this.onCommentChange,
      selectedTickets: selectedTickets,
      commentValue: comment,
      commentLength: commentLength,
      voluntaryReason: voluntaryReason,
      inVoluntaryReason: inVoluntaryReason,
      isVoluntary: isVoluntary,
      isInVoluntary: isInVoluntary,
      isCommentValid: isCommentValid,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      isButtonDisabled: isButtonDisabled,
      isLoading: isLoading,
      isPaymentOffline: isPaymentOffline,
      onFileUploaded: this.onFileUploaded,
      isFileUploaded: isFileUploaded,
      clickOnNotificationCheckbox: this.clickOnNotificationCheckbox,
      openModal: this.openModal
    }), /*#__PURE__*/React.createElement(FetchingModal, {
      url: modalUrl,
      title: I18n.t('pages.account.return_causes'),
      isOpen: isModalOpen,
      onClose: this.closeModal
    }));
  }
}